module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Bold.2d41e9f.ttf";